/* PROJECTS */
export const GET_PROVIDERS = "GET_PROVIDERS"
export const GET_PROVIDERS_SUCCESS = "GET_PROVIDERS_SUCCESS"
export const GET_PROVIDERS_FAIL = "GET_PROVIDERS_FAIL"

